/** @jsxImportSource theme-ui */
import { useSelector } from "react-redux";
import { selectUIVersion } from "store/app";
import { Box, Text, useThemeUI } from "theme-ui";
import { useEffect } from "react";
import { useAnimation, motion } from "framer-motion";

import { ProductLogos } from "components";
import { CloseIcon } from "components/icons";
import * as styles from "./AppLayout.styles";

export default function AppLayout({
  hasLoadedSelectedProduct,
  appTitle,
  appLogo,
  productLogo,
  closeAppLink,
  children,
  isDisplayingModals,
  ...props
}) {
  const {
    theme: { isMobile },
  } = useThemeUI();

  const UIVersion = useSelector(selectUIVersion);

  const controls = useAnimation();

  useEffect(() => {
    controls.start({
      height: hasLoadedSelectedProduct
        ? isMobile
          ? "calc(50% + 30px)"
          : "180px"
        : "0px",
      transition: {
        duration: 0.3,
        delay: hasLoadedSelectedProduct ? 0.5 : 0,
      },
    });
  }, [hasLoadedSelectedProduct]);

  return (
    <>
      <Box sx={styles.appLayout({ isDisplayingModals })} {...props}>
        {UIVersion === 1 && appLogo?.url && (
          <Box sx={styles.appHeader}>
            <ProductLogos appLogo={appLogo} productLogo={productLogo}>
              {appTitle && <Text variant="h5Light">{appTitle}</Text>}
            </ProductLogos>
          </Box>
        )}

        {closeAppLink && UIVersion === 1 && (
          <Box
            as="a"
            href={closeAppLink}
            aria-label="close"
            sx={styles.closeButton}
          >
            <CloseIcon />
          </Box>
        )}
        {children}
      </Box>

      <motion.div sx={styles.bottomShadow} animate={controls} />
    </>
  );
}
